import _get from 'lodash/get';
import { call, put, select } from 'redux-saga/effects';

import { selectors as routerSelectors } from 'modules/router';
import history from 'store/history';
import { getMFALoginContext, getMFARouteByStatus } from 'utils/mfa';

import * as mfaActions from '../actions';

/**
 * Start the MFA flow for the MFA requirement returned by the authenticate API,
 * i.e. send an enrolled user to the verification screen and a user without an
 * enrolled method to the setup screen.
 * We keep the current `search` (i.e. the `from` deep link) on the MFA route,
 * so the post sign in redirect still works once the code has been verified.
 *
 * @method startMFAFlowSaga
 * @type   {Generator}
 * @param  {Object}         params
 * @param  {Object}         params.requirement  The MFA requirement
 * @param  {Object}         [params.loginCreds] The login credentials
 */
export function* startMFAFlowSaga({ loginCreds = {}, requirement = {} } = {}) {
    const location = yield select(routerSelectors.getLocation);
    const search = _get(location, 'search', '');
    const pathname = getMFARouteByStatus(_get(requirement, 'status', ''));

    yield put(
        mfaActions.setMFASession({
            ...requirement,
            loginContext: getMFALoginContext(loginCreds),
        })
    );

    yield call([history, history.push], { pathname, search });
}

export default startMFAFlowSaga;
